import * as MicrosoftGraph from '@microsoft/microsoft-graph-types';
import { getUserEmail } from './outlookItemUtils';

export function getDirectionForGraphItem(item: MicrosoftGraph.Message) {
  const userEmail = getUserEmail(undefined);
  const senderEmail = item.from.emailAddress.address;

  return senderEmail?.toLowerCase() === userEmail?.toLowerCase() ? 'OUT' : 'IN';
}
